export default "__VITE_ASSET__MK0E9SW4__"